var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import queryString from 'query-string';
import { config } from '../config';
/**
 * URL生成器
 *
 * @class URLs
 */
var URLs = /** @class */ (function () {
    function URLs() {
    }
    /**
     * 登录结果返回地址
     *
     * @returns {string}
     * @memberof URLs
     */
    URLs.prototype.getAuthReturnUrl = function () {
        var curPageUrl = window.document.location.hash;
        var retrunPath = curPageUrl.split('?')[0];
        var curQueryParams = queryString.parse(queryString.extract(curPageUrl));
        var code = curQueryParams.code, state = curQueryParams.state, extraQueryParams = __rest(curQueryParams, ["code", "state"]);
        var extraQueryStr = queryString.stringify(extraQueryParams);
        return config.BASE_URL + "/" + retrunPath + "?" + extraQueryStr;
    };
    /**
     * 微信OAuth登录请求地址
     *
     * @returns {string}
     * @memberof URLs
     */
    URLs.prototype.getSyncWechatOAuthUrl = function () {
        var encodedReturnUrl = encodeURIComponent(this.getAuthReturnUrl());
        return config.API_ENDPOINT + "/auth/wechat/sync?cb_url=" + encodedReturnUrl;
    };
    URLs.prototype.getWechatOAuthUrl = function (appId) {
        var returnUrl = this.getAuthReturnUrl();
        var encodedReturnUrl = encodeURIComponent(returnUrl);
        var authUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + encodedReturnUrl + "&response_type=code&scope=snsapi_userinfo#wechat_redirect";
        return authUrl;
    };
    return URLs;
}());
var urls = new URLs();
export { urls };
//# sourceMappingURL=urls.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/services/urls.js
// module id = 1120
// module chunks = 0